import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import SoftButton from "components/SoftButton";
import SoftTypography from "components/SoftTypography";
import { useTranslation } from "react-i18next";

export const ActiveVersionDialog = ({ open, onClose, onActive }) => {
  const { t } = useTranslation("flowDesigner");

  return (
    <Dialog
      fullWidth={true}
      maxWidth={"sm"}
      open={open}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      className="active-version-dialog"
    >
      <DialogTitle data-testid="form-title">Set Version to Active</DialogTitle>
      <DialogContent>
        <SoftTypography sx={{ fontSize: "1rem" }}>Make this your active version?</SoftTypography>
      </DialogContent>
      <DialogActions className="flow-version-menu">
        <SoftButton variant="outlined" color="info" onClick={onClose}>
          {t("buttons.cancel")}
        </SoftButton>
        <SoftButton variant="contained" color="info" onClick={onActive}>
          Confirm
        </SoftButton>
      </DialogActions>
    </Dialog>
  );
};
